module.exports = __webpack_public_path__ + "img/AddPosHelp3.eea1194d.png";